import { render, staticRenderFns } from "./AprovacaoSolicitacao.vue?vue&type=template&id=6e1c9de8&"
import script from "./AprovacaoSolicitacao.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports